/*
 * @Descripttion: 
 * @version: 
 * @Author: Francis
 * @Date: 2022-07-26 09:38:07
 * @LastEditors: Francis
 * @LastEditTime: 2022-07-27 00:33:56
 */
import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate'
Vue.use(Vuex);
const config = {
  plugins: [createPersistedState()],
  state: {
    isLogin: false,
    userInfo: {},
    token: '',
    role: null
  },
  getters: {
    isLogin: state => state.isLogin,
    token: state => state.token,
    userInfo: state => state.userInfo,
    role: state => state.role
  },
  mutations: {
    updateLogin(state, payload) {
      state.isLogin = payload;
    },
    updateToken(state, payload) {
      state.token = payload;
    },
    updateUserInfo(state, payload) {
      state.userInfo = payload;
    },
    updateRole(state, payload) {
      state.role = payload;
    }
  },
  actions: {}
}
const store = new Vuex.Store(config);
export default store;